import { FormDatePicker as ExprWorksFormDatePicker } from '@diagentech/exprworks-ui-components';
import React, { useMemo } from 'react';

import { useAppSelector } from '@/App/hooks';
import { selectAppConfig } from '@/features/config/selectAppConfig';
import { withDisplayRule } from '@/features/displayRules/withDisplayRule';
import { selectLocale } from '@/features/i18n/selectLocale';
import { selectDateFormat } from '@/features/user/selectDateFormat';
import { formatDate } from '@/helpers/date/formatDate';
import { parseDate } from '@/helpers/date/parseDate';
import localizationService from '@/services/LocalizationService';

import { FormDatePickerProps } from './FormDatePickerProps';

export const FormDatePickerBase: React.FC<FormDatePickerProps> = (props) => {
  const locale = useAppSelector(selectLocale);
  const dateFormat = useAppSelector(selectDateFormat);
  const { dateFormat: serverFormat, systemMinDate, systemMaxDate } = useAppSelector(selectAppConfig);
  const localization = useMemo(() => localizationService.getDatePickerLocalization(locale), [locale]);

  return (
    <ExprWorksFormDatePicker
      dateFormat={dateFormat}
      serverDateFormat={serverFormat}
      systemMinDate={systemMinDate}
      systemMaxDate={systemMaxDate}
      localization={localization}
      formatDate={formatDate}
      parseDate={parseDate}
      {...props}
    />
  );
};

export const FormDatePicker = withDisplayRule(FormDatePickerBase);
